import React from 'react'
import styled from 'styled-components'
import { Wrapper } from '@farewill/ui'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'

const StyledLockupWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 22px;
`

const StyledGOSHLink = styled.a`
  margin-top: -6px;
`

const GOSHXFarewillLogo = () => (
  <StyledLockupWrapper noTrim>
    <StyledGOSHLink
      aria-label="Visit Great Ormond Street Hospital Children's Charity's homepage"
      href="https://www.gosh.org/"
    >
      <img
        alt="Great Ormond Street Hospital Children's Charity"
        height="55"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/gosh/gosh-logo.svg`}
      />
    </StyledGOSHLink>
    <a aria-label="Visit Farewill's homepage" href="https://farewill.com">
      <img
        alt="Great Ormond Street Hospital Children's Charity"
        height="40"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/x-Farewill.svg`}
      />
    </a>
  </StyledLockupWrapper>
)

export default GOSHXFarewillLogo
